import { useDispatch } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import Menu, { MenuItem, type MenuProps } from '@/components/Menu';
import { CLEAR_READ_FILTER } from './constants';
import {
  classes,
  clearAllNotifications,
  clearReadNotifications,
  readAllNotifications,
} from './utils';

export interface NotificationsOptionsMenuProps extends MenuProps {}

export default function NotificationsOptionsMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  onClose,
}: NotificationsOptionsMenuProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();

  const handleReadAll = () => {
    try {
      readAllNotifications();
      dispatch.updateAllNotifications({ isRead: true });
      dispatch.setUnreadNotificationsCount(0);
      onClose();
    } catch (err) {
      onApiError(err, 'Error updating notifications');
    }
  };

  const handleClearRead = () => {
    try {
      clearReadNotifications();
      dispatch.deleteAllNotifications({ filter: CLEAR_READ_FILTER });
      onClose();
    } catch (err) {
      onApiError(err, 'Error clearing notifications');
    }
  };

  const handleClearAll = () => {
    try {
      clearAllNotifications();
      dispatch.deleteAllNotifications({ filter: undefined });
      dispatch.setUnreadNotificationsCount(0);
      onClose();
    } catch (err) {
      onApiError(err, 'Error clearing notifications');
    }
  };

  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <MenuItem label={'Mark all as read'} onClick={handleReadAll} />
      <MenuItem label={'Clear read'} onClick={handleClearRead} />
      <MenuItem
        className={classes.clearAll}
        label={'Clear all'}
        onClick={handleClearAll}
      />
    </Menu>
  );
}
